module.exports = __webpack_public_path__ + "static/media/phone.1b584a53.svg";